<article [ngClass]="theme.getThemeClass()">
  <gridster [ngClass]="theme.getThemeClass()" [options]="gridsterOptions" style="height: 100vh!important;">
    @for (item of navigationItemsArray; track item.name) {
      @if (item.name !== 'sidenavMenu.HOME') {
      <gridster-item  [item]="item">
        <!-- Your tile content goes here -->
        <nav [ngClass]="theme.getThemeClass()" class="dashboard-tile">
          <header class="dashboard-tile-header">
            <h6 class="dashboard-tile-title"><a [routerLink]="['/', item.routeUrl]">{{item.name | translate}}</a></h6>
            <span class="dashboard-tile-action-container">

              <a class="nav-link e" href="javascript:void(0);" style="border: none;"  data-bs-toggle="dropdown">
                <i class="fa fa-bars"></i>
              </a>
              <ul [ngClass]="theme.getThemeClass()" class="ulDrop dropdown-menu dropdown-menu-light">
                <!-- Menu Items -->
                @for (action of item.actions; track action.title) {
                  @if (action.title) {
                  <li class="actionsTitle">{{ action.title | translate }}</li>
                  }
                  @for (option of action.options; track option.name) {
                    <li class="actionsOption">
                      <a [ngClass]="[theme.getThemeClass(), action.title === 'graphs' ? 'disabled-link' : '']" (click)="handleLinkClick($event, option.route)" [routerLink]="['/', option.route]">
                        <i class="textAlignCenter" [ngClass]="option.icon"></i>
                        <span class="customMarginLeft1">
                          {{ option.name | translate }}
                        </span>
                      </a>
                    </li>
                  }
                }
              </ul>
            </span>
          </header>
          <div [ngClass]="theme.getThemeClass()"  class="dashboard-tile-content">
            <!-- <app-loading-element></app-loading-element> -->
            @if (!dashboardService.stopLoading && item.name !== 'sidenavMenu.ZONES') {
            <nav class="loading-gif">
              <!-- Container with box styles and fade-in-out animation -->
                <div class="box fade-in-out" >
                  <!-- Font Awesome spinner icon with custom styles -->
                  <div class="fa-3x mb-2">
                      <i class="fa-solid fa-spinner fa-spin-pulse fa-2xl color"></i>
                  </div>
                  <!-- Logo container with dynamic theme class and navigation link -->
                  <div>
                      <a [ngClass]="theme.getThemeClass()"
                      class=" hide-too-small-screen navbar-brand px-1" href="javascript:void(0);" data-bs-toggle="dropdown">
                          <!-- Logo image with custom styles -->
                          <img class="logo" src="../assets/muirwood-studio.png">
                      </a>
                  </div>
                </div>
              </nav>
            }
            <!-- Section for charts -->
            @if (item.name === 'sidenavMenu.distributor.IOT') {
            <app-pie-chart></app-pie-chart>
            }
            @if (item.name === 'sidenavMenu.distributor.BINS') {
            <app-bar-chart></app-bar-chart>
            }
            @if (item.name === 'sidenavMenu.distributor.ADMIN') {
            <app-bar-chart-admin></app-bar-chart-admin>
            }
            @if (item.name === 'sidenavMenu.distributor.WORKORDER') {
            <app-pie-chart-single></app-pie-chart-single>
            }
          </div>
        </nav>
      </gridster-item>
      }
    }
  </gridster>
</article>
